import React, { useEffect, useRef, useState } from "react";
import { MuiOtpInput } from "mui-one-time-password-input";
import { FormHelperText } from "@mui/material";
import useKeyboard from "@shared/modules/utils/Keyboard/useKeyboard";
import EventService from "@shared/services/EventService";
import { scrollFieldIntoViewIfHidden } from "./constants";

const OtpField = React.forwardRef(
    (
        {
            label,
            errorMsg,
            value,
            onChangeInput,
            sizeRange,
            allowedSizes,
            containerClass,
            showKeyboard = true,
            enableScrollFieldIfHiddenEvent = true,
            length,
            virtualKeyboardLayout = null,
            virtualKeyboardLang = "en",
            ...restProps
        },
        ref
    ) => {
        const otpContainerRef = useRef(null);

        const [brVal, setBrVal] = useState(true);
        const [fieldfocus, setFocus] = useState(false);

        const focusRef = useRef(false); //focus state is "stale" in subscribe event

        useEffect(() => {
            let eventInput = EventService.subscribe("keypad.blur", bool => {
                setBrVal(bool);
            });
            let eventInput2 = EventService.subscribe("keypad.focus", bool => {
                ref.current?.blur
                setFocus(true);
            });

            let scrollEvent = enableScrollFieldIfHiddenEvent
                ? EventService.subscribe("keyboard.show", () => {
                    if (focusRef.current) {
                        scrollFieldIntoViewIfHidden(ref);
                    }
                })
                : {};

            return () => {
                eventInput.remove();
                eventInput2.remove();
                if (scrollEvent.remove) scrollEvent.remove();
            };
        });

        useEffect(() => {
            // This handling is specifically done for length 6 because MuiOtpInput library 
            // has improper side-effects when length is 6,
            // it highlights the last element, hence manually focussing the first(out of 6) input field
            if (length === 6) {
                // Delay so it overrides internal focusing
                setTimeout(() => {
                    const firstInput = otpContainerRef.current?.querySelector("input");
                    firstInput?.focus();
                }, 0);
            }
        }, [length]);

        const handleInputChange = newValue => {
            if (isValid(newValue)) {
                onChangeInput(newValue);
            }
        };
        const handelBlur = () => {
            if (brVal) {
                EventService.publish("keyboard.hide");
                setFocus(false);
                focusRef.current = false;
            } else {
                setBrVal(true);
                setFocus(true);
                focusRef.current = true;
            }
        };

        const isValid = value => {
            if (sizeRange) {
                let max = sizeRange[1];
                if (max !== -1 && String(value).split(".")[0].length > max) {
                    return false;
                }
            }

            if (allowedSizes && allowedSizes.length !== 0) {
                let largest = Math.max(...allowedSizes);
                if (String(value).length > largest) return false;
            }

            return true;
        };

        const { openKeyboard } = useKeyboard(value, handleInputChange);
        return (
            <div
                ref={otpContainerRef}
                className={`input-field-sec otp-fields ${errorMsg ? "error-field" : ""} ${fieldfocus ? "blurFocus" : ""} ${
                    containerClass || ""
                }`}
            >
                <MuiOtpInput
                    inputRef={ref}
                    TextFieldsProps={{
                        inputRef:ref,
                        placeholder: (index) => index===value.length ? `|`:"" 
                    }}
                    helperText={label}
                    value={value}
                    onChange={e => handleInputChange(e)}
                    length={length}
                    autoFocus={true}
                    onFocus={() => {
                        focusRef.current = true;
                        showKeyboard &&
                        openKeyboard({
                            layoutName: virtualKeyboardLayout || "default",
                            virtualKeyboardLang: virtualKeyboardLang
                        })
                    }}
                    variant="outlined"
                    {...restProps}
                    onBlur={handelBlur}
                />
                <FormHelperText>{label}</FormHelperText>
                {errorMsg && <span className="helperTextError">{errorMsg}</span>}
            </div>
        );
    }
);

export default OtpField;
